export const Title = ({ text }: any) => {
  return (
    <div className="flex-column gap-5  padding-16-16-8-16">
      <div className="font-bold f-size-16 line-h-24 color-text-primary">
        {text}
      </div>
    </div>
  );
};
